import { UseMutationResult, useMutation } from 'react-query'
import request from '../request'

type DataType = { agency_id: number }
export const useDownloadAllOpenInvoices = (): UseMutationResult<any, any, any> => {
  return useMutation<any, any, any>((data: DataType) =>
    request({
      url: `/agencies/${data.agency_id}/invoices/open/download`,
      method: 'GET',
      credentials: 'include',
    }),
  )
}
